import React, { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { TriangleAlertIcon } from 'lucide-react';

import { useVacantProperties } from 'src/services/api/properties/use-vacant-properties';
import { usePersistentState } from 'src/services/storage/use-persistent-state';
import analyticsClient, { AnalyticsEvent } from 'src/services/analytics';
import AlertCard from 'src/components/alerts/AlertCard';

const DISMISS_EXPIRED_DAYS = 7;

export default function VacantPropertiesAlert() {
    const data = useVacantProperties();
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const [isDismissed, setIsDismissed] = usePersistentState('vacantPropertiesAlertDismissed', false);

    const handleDismiss = useCallback(() => {
        analyticsClient.track(AnalyticsEvent.CLICKED_ON_DISMISS_VACANT_ALERT);
        setIsDismissed(true, new Date(Date.now() + DISMISS_EXPIRED_DAYS * 24 * 60 * 60 * 1000));
    }, []);

    const handleGoToProperties = useCallback(() => {
        analyticsClient.track(AnalyticsEvent.CLICIKED_ON_GO_TO_PROPERTIES_IN_VACANT_ALERT);
        navigate('/landlord/inner/properties?filter=%7B"possiblyFilled"%3Atrue%7D');
    }, []);

    if (!data?.possiblyFilledPropertiesAmount || isDismissed) {
        return null;
    }

    if (pathname.startsWith('/landlord/inner/properties')) {
        return null;
    }

    const count = data.possiblyFilledPropertiesAmount;

    return (
        <AlertCard
            icon={<TriangleAlertIcon size={22} color="#f59e0b" />}
            title="Review Vacant Properties"
            description={`${count} ${count === 1 ? 'property is' : 'properties are'} possibly filled. Please review and update their leasing status.`}
            borderColor="#f59e0b"
            actions={
                <>
                    <Button variant="outlined" color="inherit" size="small" onClick={handleGoToProperties} sx={{ fontWeight: 600 }}>
                        Go to Properties
                    </Button>
                    <Button variant="text" color="inherit" size="small" onClick={handleDismiss}>
                        Dismiss
                    </Button>
                </>
            }
        />
    );
}
